"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread2"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _Base = require("../common/Base");
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["platform", "base", "projectId", "branch"];
var Codacy = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var _props$platform = props.platform,
    platform = _props$platform === void 0 ? 'coveralls' : _props$platform,
    _props$base = props.base,
    base = _props$base === void 0 ? 'https://img.shields.io' : _props$base,
    projectId = props.projectId,
    branch = props.branch,
    other = (0, _objectWithoutProperties2["default"])(props, _excluded);
  var getUrl = function getUrl() {
    if (platform !== 'coveralls') return '';
    if (branch) return [base, platform, projectId, branch].join('/');
    return [base, 'codacy/coverage', projectId].join('/');
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Base.Internal, (0, _objectSpread2["default"])({
    imgSrc: getUrl(),
    ref: ref
  }, other));
});
Codacy.displayName = 'Codacy';
var _default = exports["default"] = Codacy;
module.exports = exports.default;